<template>
  <div>
    <el-dialog
      :title="title==''?'选人':title"
      :visible.sync="candidate"
      width="61.8%"
      :before-close="closecandidate"
      :append-to-body="true"
    >
      <div class="clearfix" style="height:100%">
        <div class="candidate-left fl">
          <div class="candidate-left-search">
            <i class="iconfont searchBtn">&#xe603;</i>
            <input
              type="text"
              v-model="searchText"
              placeholder="回车搜索人员"
              @keyup.enter="candidateSearch"
            />
          </div>
          <div class="tab">
            <ul class="tablist">
              <li
                @click="changetype(item)"
                :class="{'active':usertypeActive==item}"
                v-for="(item,index) in usertype"
                :key="index"
              >
                <span v-if="item==0">最近联系</span>
                <span v-if="item==1">好友</span>
                <span v-if="item==2">群</span>
                <span v-if="item==3">组织</span>
                <span v-if="item==4">角色</span>
                <span v-if="item==5">标签</span>
                <span v-if="item==6">群成员</span>
                <span v-if="item==7">行业</span>
                <span v-if="item==8">区域</span>
              </li>
            </ul>
            <ul class="tabbox">
              <ul class="clearfix breadcrumb" v-if="usertypeActive==3">
                <li class="fl" v-for="(item,index) in breadcrumb">
                  <span
                    @click="nextdept(item.name,item.orgid,item.deptno,item.type)"
                    :class="{'last':index==breadcrumb.length-1}"
                  >{{item.name}}</span>
                  <span class="last el-icon-arrow-right" v-show="index<breadcrumb.length-1"></span>
                </li>
              </ul>
              <ul class="clearfix breadcrumb" v-if="usertypeActive==7||usertypeActive==8">
                <li class="fl" v-for="(item,index) in breadcrumb">
                  <span
                    @click="next(usertypeActive,item.id)"
                    :class="{'last':index==breadcrumb.length-1}"
                  >{{item.name}}</span>
                  <span class="last el-icon-arrow-right" v-show="index<breadcrumb.length-1"></span>
                </li>
              </ul>
              <li>
                <el-checkbox
                  v-model="radioStatus"
                  :disabled="createtype=='addFriend'||createtype=='administrators'||createtype=='assignment'||createtype=='soldierinfo'"
                  @change="checkall($event,userlist)"
                >全选</el-checkbox>
              </li>
              <el-checkbox-group :max="limit==-1?99999999:limit" v-model="checklist">
                <li class="clearfix" v-for="(m,i) in userlist">
                  <el-checkbox
                    v-if="chooseorg&&usertypeActive!='7'&&usertypeActive!='8'"
                    class="vCenter fl"
                    :label="m.id"
                    @change="checkChange($event,m)"
                    :disabled="m.type!='1'||m.disabled"
                  >
                    <div class="vCenter">
                      <img
                        :src="m.avatar"
                        alt
                        class="userHeadImg"
                        v-if="m.avatar!=undefined&&m.type!='2'"
                      />
                      <div
                        v-if="(m.avatar==null||m.avatar==undefined)&&m.type!='2'"
                        class="userHeadImg defaultAvatar"
                      >{{avaname(m.name)}}</div>
                      <div class="name">{{m.name}}</div>
                    </div>
                  </el-checkbox>
                  <el-checkbox
                    v-if="!chooseorg&&usertypeActive!='7'&&usertypeActive!='8'"
                    class="vCenter fl"
                    :label="m.id"
                    @change="checkChange($event,m)"
                    :disabled="m.disabled||(createtype=='soldierinfo'&&m.type!='2')"
                  >
                    <div class="vCenter">
                      <img
                        :src="m.avatar"
                        alt
                        class="userHeadImg"
                        v-if="m.avatar!=undefined&&m.type!='2'"
                      />
                      <div
                        v-if="(m.avatar==null||m.avatar==undefined)&&m.type!='2'"
                        class="userHeadImg defaultAvatar"
                      >{{avaname(m.name)}}</div>
                      <div class="name">{{m.name}}</div>
                    </div>
                  </el-checkbox>
                  <el-checkbox
                    v-if="usertypeActive=='7'||usertypeActive=='8'"
                    class="vCenter fl"
                    :label="m.id"
                    @change="checkChange($event,m)"
                  >
                    <div class="vCenter">
                      <div class="name">{{m.name}}</div>
                    </div>
                  </el-checkbox>
                  <div
                    v-if="usertypeActive==3&&m.type!='1'"
                    :class="['fr nextdept']"
                    @click.stop="nextdept(m.name,m.orgid,m.deptno,m.type)"
                  >下级</div>
                  <div
                    v-if="(usertypeActive==7||usertypeActive==8)&&m.level<4"
                    :class="['fr nextdept']"
                    @click.stop="next(usertypeActive,m.id,m.name)"
                  >下级</div>
                </li>
              </el-checkbox-group>
            </ul>
          </div>
          <el-pagination
            layout="prev, pager, next"
            @current-change="currentChange"
            :total="total"
            :hide-on-single-page="1"
            v-if="usertypeActive==='3'"
          ></el-pagination>
        </div>
        <div class="candidate-right fl">
          <ul>
            <!-- <li v-for="(item,index) in usertype"> -->
            <li>
              <div v-if="usertype.indexOf('1')!=-1||usertype.indexOf('3')!=-1">
                <div class="vCenter">
                  <span class="line"></span>
                  <span>已选好友：</span>
                </div>
                <el-tag
                  v-for="(tag,index) in tagsFriend"
                  :key="tag.name"
                  :closable="!tag.disabled"
                  @close="closeTag(1,index,tag)"
                  :type="tag.type"
                >{{tag.name}}</el-tag>
                <div v-if="tagsFriend.length==0" class="occupy"></div>
              </div>
              <div v-if="usertype.indexOf('6')!=-1">
                <div class="vCenter">
                  <span class="line"></span>
                  <span>
                    已选群成员：
                    <span v-if="limit!=-1">（{{tagsFriend.length}}/{{limit}}）</span>
                  </span>
                </div>
                <el-tag
                  v-for="(tag,index) in tagsFriend"
                  :key="tag.name"
                  :closable="!tag.disabled"
                  @close="closeTag(1,index,tag)"
                  :type="tag.type"
                >{{tag.name}}</el-tag>
                <div v-if="tagsFriend.length==0" class="occupy"></div>
              </div>
              <div v-if="usertype.indexOf('2')!=-1">
                <div class="vCenter">
                  <span class="line"></span>
                  <span>已选群：</span>
                </div>
                <el-tag
                  v-for="(tag,index) in tagsGroup"
                  :key="tag.name"
                  closable
                  @close="closeTag(2,index,tag)"
                  :type="tag.type"
                >{{tag.name}}</el-tag>
                <div v-if="tagsGroup.length==0" class="occupy"></div>
              </div>
              <div v-if="!chooseorg">
                <div class="vCenter">
                  <span class="line"></span>
                  <span>已选组织：</span>
                </div>
                <el-tag
                  v-for="(tag,index) in tagsOrg"
                  :key="tag.name"
                  closable
                  @close="closeTag(3,index,tag)"
                  :type="tag.type"
                >{{tag.name}}</el-tag>
                <div v-if="tagsOrg.length==0" class="occupy"></div>
              </div>
              <div v-if="usertype.indexOf('7')!=-1">
                <div class="vCenter">
                  <span class="line"></span>
                  <span>已选行业：</span>
                </div>
                <el-tag
                  v-for="(tag,index) in tagshy"
                  :key="tag.name"
                  :closable="!tag.disabled"
                  @close="closeTag(7,index,tag)"
                  :type="tag.type"
                >{{tag.name}}</el-tag>
                <div v-if="tagsFriend.length==0" class="occupy"></div>
              </div>
              <div v-if="usertype.indexOf('8')!=-1">
                <div class="vCenter">
                  <span class="line"></span>
                  <span>已选地区：</span>
                </div>
                <el-tag
                  v-for="(tag,index) in tagsdq"
                  :key="tag.name"
                  :closable="!tag.disabled"
                  @close="closeTag(8,index,tag)"
                  :type="tag.type"
                >{{tag.name}}</el-tag>
                <div v-if="tagsFriend.length==0" class="occupy"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closecandidate">取 消</el-button>
        <el-button type="primary" @click="submitcandidate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "umCandidate",
  props: [
    "isradio",
    "candidate",
    "usertype",
    "friend",
    "org",
    "group",
    "hy",
    "dq",
    "chooseorg",
    "createtype",
    "limit",
    "title",
    "orgname",
    "orgid"
  ],
  data() {
    return {
      checklist: [],
      usertypeActive: this.usertype[0],
      userlist: [],
      tagsFriend: [],
      tagsGroup: [],
      tagsOrg: [],
      tagshy: [],
      tagsdq: [],
      dtagsFriend: [],
      dtagsGroup: [],
      dtagsOrg: [],
      dtagshy: [],
      dtagsdq: [],
      breadcrumb: [],
      radioStatus: false,
      isIndeterminate: true,
      searchText: "",
      total: 0
    }
  },
  mounted() {
    if (this.usertypeActive == 0) {
      this.changetype("0")
    } else if (this.usertypeActive == 1) {
      this.changetype("1")
    } else if (this.usertypeActive == 2) {
      this.changetype("2")
    } else if (this.usertypeActive == 3) {
      if (
        this.createtype == "orgadmin" ||
        this.createtype == "orgnewadmin" ||
        this.createtype == "orgdept" ||
        this.createtype == "soldierinfo"
      ) {
        this.nextdept(this.orgname, this.orgid, "", 3)
      } else {
        this.changetype("3")
      }
    } else if (this.usertypeActive == 4) {
    } else if (this.usertypeActive == 5) {
    } else if (this.usertypeActive == 6) {
      if (this.createtype == "administrators") {
        this.friend.forEach(m => {
          if (m.id != $UMCore.uncompile("umid")) {
            this.userlist.push(m)
          }
        })
        this.friend = []
        this.userlist.forEach(m => {
          if (m.usertype == "1") {
            this.friend.push(m)
          }
        })
      } else if (this.createtype == "estoppeluser") {
        this.friend.forEach(m => {
          if (m.id != $UMCore.uncompile("umid")) {
            this.userlist.push(m)
          }
        })
        this.friend = []
        this.userlist.forEach(m => {
          if (m.gagorder == 1) {
            this.friend.push(m)
          }
        })
      } else if (this.createtype == "assignment") {
        this.friend.forEach(m => {
          if (m.id != $UMCore.uncompile("umid")) {
            this.userlist.push(m)
          }
        })
        this.friend = []
      } else {
        this.userlist = this.friend
        this.friend = []
      }
    } else if (this.usertypeActive == 7) {
      this.changetype("3")
    } else if (this.usertypeActive == 8) {
      this.changetype("3")
    }
    this.friend.forEach(m => {
      this.checklist.push(m.id)
    })
    this.org.forEach(m => {
      this.checklist.push(m.id)
    })
    this.group.forEach(m => {
      this.checklist.push(m.id)
    })
    this.hy.forEach(m => {
      this.checklist.push(m.id)
    })
    this.dq.forEach(m => {
      this.checklist.push(m.id)
    })
    if (this.createtype != "audiochat" && this.createtype != "videochat") {
      this.dtagsFriend = [...this.friend]
      this.dtagsGroup = [...this.group]
      this.dtagsOrg = [...this.org]
      this.dtagshy = [...this.hy]
      this.dtagsdq = [...this.dq]
      this.tagsFriend = this.tagsFriend.concat(this.dtagsFriend)
      this.tagsGroup = this.tagsGroup.concat(this.dtagsGroup)
      this.tagsOrg = this.tagsOrg.concat(this.dtagsOrg)
      this.tagshy = this.tagshy.concat(this.dtagshy)
      this.tagsdq = this.tagsdq.concat(this.dtagsdq)
      if (this.createtype == "addFriend") {
        this.tagsFriend.forEach(m => {
          this.friend.forEach(n => {
            if (m.id == n.id) {
              m.disabled = true
            }
          })
        })
        this.compare(1)
      }
    }
  },
  methods: {
    /**
     * 搜索
     */
    candidateSearch() {
      this.nextdept(
        this.breadcrumb[0].name,
        this.breadcrumb[0].orgid,
        this.breadcrumb[this.breadcrumb.length - 1].deptno,
        3
      )
    },
    next(i, id, name) {
      if (i == "7") {
        $UMCore
          .post(window.zt_server + "/route.lua", {
            data: JSON.stringify({
              modulename: "industry",
              functionname: "get",
              pid: id
            })
          })
          .then(res => {
            this.userlist = res.data.data.slist
            this.compare(i)
            var s = false
            this.$nextTick(() => {
              if (this.breadcrumb.length > 0) {
                for (let index = 0; index < this.breadcrumb.length; index++) {
                  if (id == this.breadcrumb[index].id) {
                    s = true
                    this.breadcrumb = this.breadcrumb.slice(0, index + 1)
                    break
                  }
                }
              } else {
                this.breadcrumb.push({
                  id: id,
                  name: name
                })
              }
            })
            if (!s) {
              this.breadcrumb.push({
                id: id,
                name: name
              })
            }
          })
      } else if (i == "8") {
        $UMCore
          .post(window.zt_server + "/route.lua", {
            data: JSON.stringify({
              modulename: "area",
              functionname: "get",
              pid: id
            })
          })
          .then(res => {
            this.userlist = res.data.data.slist
            this.compare(i)
            var s = false
            this.$nextTick(() => {
              if (this.breadcrumb.length > 0) {
                for (let index = 0; index < this.breadcrumb.length; index++) {
                  if (id == this.breadcrumb[index].id) {
                    s = true
                    this.breadcrumb = this.breadcrumb.slice(0, index + 1)
                    break
                  }
                }
              } else {
                this.breadcrumb.push({
                  id: id,
                  name: name
                })
              }
            })
            if (!s) {
              this.breadcrumb.push({
                id: id,
                name: name
              })
            }
          })
      }
    },
    avaname(name) {
      if (name != undefined) {
        return name.substr(name.length - 2, 2)
      }
    },
    checkall(val, list) {
      if (val) {
        for (var i = 0; i < list.length; i++) {
          this.checklist.push(list[i].id)
          if (
            list[i].itype == "1" ||
            (list[i].type == "1" && list[i].itype == "3")
          ) {
            for (var j = 0; j < this.tagsFriend.length; j++) {
              if (list[i].id == this.tagsFriend[j].id) {
                this.tagsFriend.splice(j, 1)
                j = j - 1
              }
            }
            this.tagsFriend.push(list[i])
          } else if (list[i].itype == "2") {
            this.tagsGroup.push(list[i])
          } else if (list[i].itype == "3" && list[i].type != "1") {
            this.tagsOrg.push(list[i])
          }
        }
      } else {
        for (var i = 0; i < list.length; i++) {
          this.checklist = []
          if (
            list[i].itype == "1" ||
            (list[i].type == "1" && list[i].itype == "3")
          ) {
            for (var j = 0; j < this.tagsFriend.length; j++) {
              if (list[i].id == this.tagsFriend[j].id) {
                this.tagsFriend.splice(j, 1)
                j = j - 1
              }
            }
          } else if (list[i].itype == "2") {
            for (var j = 0; j < this.tagsGroup.length; j++) {
              if (list[i].id == this.tagsGroup[j].id) {
                this.tagsGroup.splice(j, 1)
                j = j - 1
              }
            }
          } else if (list[i].itype == "3" && list[i].type != "1") {
            for (var j = 0; j < this.tagsOrg.length; j++) {
              if (list[i].id == this.tagsOrg[j].id) {
                this.tagsOrg.splice(j, 1)
                j = j - 1
              }
            }
          }
        }
      }
    },
    closecandidate() {
      this.$emit(
        "closecandidate",
        this.dtagsFriend,
        this.dtagsGroup,
        this.dtagsOrg,
        this.dtagshy,
        this.dtagsdq
      )
    },
    changetype(i) {
      this.usertypeActive = i
      this.breadcrumb = []
      if (i == "1" || i == "2" || i == "3") {
        $UMCore
          .post("/route.lua", {
            data: JSON.stringify({
              functionname: "userlist_get",
              itype: i,
              umid: $UMCore.uncompile("umid"),
              page: 0,
              pagesize: 10
            })
          })
          .then(res => {
            if (res.data.status) {
              this.userlist = res.data.slist
              if (this.usertypeActive === '3') {
                this.total = parseInt(res.data.recordcount)
              }
              if (this.createtype == "addFriend") {
                this.userlist.forEach(m => {
                  this.friend.forEach(n => {
                    if (m.id == n.id) {
                      m.disabled = true
                    }
                  })
                })
              }
              this.compare(i)
            }
          })
      } else if (i == "0") {
        $UMCore
          .post("/route.lua", {
            data: JSON.stringify({
              functionname: "msg_getdisuser",
              umid: $UMCore.uncompile("umid")
            })
          })
          .then(res => {
            var list = res.data.result.slice(0, 10),
              a = []
            list.forEach(m => {
              if (m.type == 1) {
                a.push({
                  id: m.users.umid,
                  name: m.users.sumname,
                  avatar: m.users.avatar,
                  type: "1",
                  itype: "1"
                })
              } else {
                a.push({
                  id: m.roominfo.roomid,
                  name: m.roominfo.roomname,
                  avatar: m.roominfo.logopath,
                  type: "1",
                  itype: "2"
                })
              }
            })
            this.userlist = a
            if (this.createtype == "addFriend") {
              this.userlist.forEach(m => {
                this.friend.forEach(n => {
                  if (m.id == n.id) {
                    m.disabled = true
                  }
                })
              })
            }
            this.compare(i)
          })
      } else if (i == "7") {
        $UMCore
          .post(window.zt_server + "/route.lua", {
            data: JSON.stringify({
              modulename: "industry",
              functionname: "get",
              pid: 0
            })
          })
          .then(res => {
            this.userlist = res.data.data.slist
            this.compare(i)
          })
      } else if (i == "8") {
        $UMCore
          .post(window.zt_server + "/route.lua", {
            data: JSON.stringify({
              modulename: "area",
              functionname: "get",
              pid: 0
            })
          })
          .then(res => {
            this.userlist = res.data.data.slist
            this.compare(i)
          })
      }
    },
    equar(a, b) {
      // 判断数组的长度
      let c = []
      if (a.length !== b.length) {
        a.forEach(m => {
          b.forEach(n => {
            if (m == n) {
              c.push(m)
            }
          })
        })
        if (c.length == a.length) {
          return true
        } else {
          return false
        }
      } else {
        // 循环遍历数组的值进行比较
        for (let i = 0; i < a.length; i++) {
          if (b.indexOf(a[i]) == -1) {
            return false
          }
        }
        return true
      }
    },
    compare(i) {
      var list = [],
        list1 = []
      if (i == "1") {
        this.tagsFriend.forEach(m => {
          list.push(m.id)
        })
      } else if (i == "2") {
        this.tagsGroup.forEach(m => {
          list.push(m.id)
        })
      } else if (i == "3") {
        this.tagsOrg.forEach(m => {
          list.push(m.id)
        })
        this.tagsFriend.forEach(m => {
          list.push(m.id)
        })
      } else if (i == "7") {
        this.tagshy.forEach(m => {
          list.push(m.id)
        })
      } else if (i == "8") {
        this.tagsdq.forEach(m => {
          list.push(m.id)
        })
      }

      this.userlist.forEach(m => {
        list1.push(m.id)
      })
      this.checklist = list
      if (this.equar(list1, list) && this.checklist.length != 0) {
        this.radioStatus = true
      } else {
        this.radioStatus = false
      }
    },
    closeTag(type, index, tag) {
      if (type == 1) {
        this.tagsFriend.splice(index, 1)
      } else if (type == 2) {
        this.tagsGroup.splice(index, 1)
      } else if (type == 3) {
        this.tagsOrg.splice(index, 1)
      } else if (type == 7) {
        this.tagshy.splice(index, 1)
      } else if (type == 8) {
        this.tagsdq.splice(index, 1)
      }
      this.checklist.forEach((m, i) => {
        if (m == tag.id) {
          this.checklist.splice(i, 1)
        }
      })
      this.compare(type)
    },
    checkChange(val, m) {
      if (val) {
        if (m.itype == "1" || (m.itype == "3" && m.type == "1")) {
          if (this.isradio) {
            if (this.tagsFriend.length == 0 && this.tagsGroup.length == 0) {
              this.tagsFriend.push(m)
            } else {
              this.$message.error("仅支持单选！")
            }
          } else {
            this.tagsFriend.push(m)
          }
        } else if (m.itype == "2") {
          if (this.isradio) {
            if (this.tagsFriend.length == 0 && this.tagsGroup.length == 0) {
              this.tagsGroup.push(m)
            } else {
              this.$message.error("消息转发仅支持单一对象！")
            }
          } else {
            this.tagsGroup.push(m)
          }
        } else if (m.itype == "3") {
          this.tagsOrg.push(m)
        } else if (this.usertypeActive == "7") {
          this.tagshy.push(m)
        } else if (this.usertypeActive == "8") {
          this.tagsdq.push(m)
        }
      } else {
        if (m.itype == "1" || (m.itype == "3" && m.type == "1")) {
          this.tagsFriend.forEach((e, i) => {
            if (m.id == e.id) {
              this.tagsFriend.splice(i, 1)
            }
          })
        } else if (m.itype == "2") {
          this.tagsGroup.forEach((e, i) => {
            if (m.id == e.id) {
              this.tagsGroup.splice(i, 1)
            }
          })
        } else if (m.itype == "3") {
          this.tagsOrg.forEach((e, i) => {
            if (m.id == e.id) {
              this.tagsOrg.splice(i, 1)
            }
          })
        } else if (this.usertypeActive == "7") {
          this.tagshy.forEach((e, i) => {
            if (m.id == e.id) {
              this.tagshy.splice(i, 1)
            }
          })
        } else if (this.usertypeActive == "8") {
          this.tagsdq.forEach((e, i) => {
            if (m.id == e.id) {
              this.tagsdq.splice(i, 1)
            }
          })
        }
      }
      if (this.usertypeActive == "7" || this.usertypeActive == "8") {
        this.compare(this.usertypeActive)
      } else {
        this.compare(m.itype)
      }
    },
    currentChange (val) {
       $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            functionname: 'userlist_get',
            itype: '3',
            umid: $UMCore.uncompile("umid"),
            orgid: this.breadcrumb[0].orgid,
            deptno: this.breadcrumb[this.breadcrumb.length - 1].deptno,
            swhere: this.searchText,
            page: val - 1,
            pagesize: 10
          })
        })
        .then(res => {
          if (res.data.status) {
            this.userlist = res.data.slist
            if (this.usertypeActive === '3') {
              this.total = parseInt(res.data.recordcount)
            }
          }
        })
    },
    nextdept(name, orgid, deptno, type) {
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            functionname: "userlist_get",
            itype: "3",
            umid: $UMCore.uncompile("umid"),
            orgid: orgid,
            deptno: deptno,
            swhere: this.searchText,
            page: 0,
            pagesize: 10
          })
        })
        .then(res => {
          if (res.data.status) {
            this.userlist = res.data.slist
            if (this.usertypeActive === '3') {
              this.total = parseInt(res.data.recordcount)
            }
            var s = false
            this.$nextTick(() => {
              if (this.breadcrumb.length > 0) {
                for (let index = 0; index < this.breadcrumb.length; index++) {
                  if (deptno == this.breadcrumb[index].deptno) {
                    s = true
                    this.breadcrumb = this.breadcrumb.slice(0, index + 1)
                    break
                  }
                }
              } else {
                this.breadcrumb.push({
                  name: name,
                  orgid: orgid,
                  deptno: deptno,
                  type: type
                })
              }
            })
            if (!s) {
              this.breadcrumb.push({
                name: name,
                orgid: orgid,
                deptno: deptno,
                type: type
              })
            }
          }
        })
    },
    submitcandidate() {
      this.$emit(
        "submitcandidate",
        this.tagsFriend,
        this.tagsGroup,
        this.tagsOrg,
        this.tagshy,
        this.tagsdq
      )
    }
  }
}
</script>
<style lang="scss">
.candidate-left {
  width: 50%;
  border-right: 1px solid #dcdcdc;
  padding-right: 20px;
  height: 100%;
  .tab {
    display: flex;
    .tablist {
      width: 90px;
      margin-right: 20px;
      cursor: pointer;
      li {
        width: 90px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        margin-bottom: 10px;
        background: #e7e7e7;
      }
      li.active {
        background: #2e9cf1;
        color: #fff;
      }
    }

    .tabbox {
      flex: 1;
      height: 300px;
      overflow: auto;
      > div {
        margin-right: 10px;
      }
      .breadcrumb {
        margin-bottom: 10px;
        li {
          color: #2e9cf1;
          cursor: pointer;
          .last {
            color: #333;
          }
        }
      }
      li {
        display: block;
        margin-bottom: 6px;
        .userHeadImg {
          width: 28px;
          height: 28px;
          color: #fff;
          font-size: 12px;
          text-align: center;
          line-height: 28px;
          border: 0;
          margin-right: 6px;
        }
        .nextdept {
          font-size: 14px;
          display: inline-block;
          cursor: pointer;
          color: #2e9cf1;
        }
        .disabled {
          color: #b1b1b1;
          line-height: 28px;
        }
      }
      .bwn {
        justify-content: space-between;
      }
    }
  }
  .candidate-left-search {
    height: 40px;
    margin: 0 auto 20px;
    width: 100%;
    padding: 0 10px;
    border: 1px solid rgba(204, 204, 204, 1);
    border-radius: 4px;
    input {
      height: 40px;
      border: 0;
      width: 180px;
      margin-right: 10px;
      background: transparent;
    }
    i {
      color: #9e9e9e;
    }
  }
}
.candidate-right {
  width: 50%;
  padding-left: 20px;
  .occupy {
    height: 10px;
  }
  .vCenter {
    margin-bottom: 10px;
  }
  .line {
    width: 2px;
    height: 16px;
    background: rgba(46, 156, 241, 1);
    display: inline-block;
    margin-right: 5px;
  }
}
</style>
<style>
.candidate-right .el-tag {
  margin: 0 5px 5px 0;
}
.tabbox .el-checkbox {
  color: #333;
}
.tabbox .el-checkbox__inner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.tabbox .el-checkbox__inner::after {
  left: 7px;
  top: 4px;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/packages/candidate/um-candidate.vue